import { useEffect, useState } from "react";

export type HostSurface = "mail" | "calendar" | "unknown";

export function useHostSurface(): HostSurface {
  const [surface, setSurface] = useState<HostSurface>("unknown");

  useEffect(() => {
    try {
      const type = Office?.context?.mailbox?.item?.itemType;
      if (type === Office.MailboxEnums.ItemType.Message) {
        setSurface("mail");
      } else if (type === Office.MailboxEnums.ItemType.Appointment) {
        setSurface("calendar");
      }
    } catch {
      // Office context unavailable (e.g. outside Outlook) — leave "unknown".
    }
  }, []);

  return surface;
}
